module.exports = __webpack_public_path__ + "img/logo.4a1f08c7.svg";